import {RestApiService} from '../../../rest-api.service';
import {Observable} from "rxjs";
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {LicenseAssignmentCsvImportRequest, LicenseAssignmentRequest, LicenseAssignmentResponse,} from '../../../../contracts/v0/contracting/license-assignment.contract';
import {ApiV0Contracting} from '../api.v0.contracting';

export class ApiV0LicenseAssignment {
    segment: string;

    constructor(v0: ApiV0Contracting, private rest: RestApiService) {
        this.segment = v0.segment + '/licenseAssignment';
    }

    list(): Observable<BaseCollectionModel<LicenseAssignmentResponse>> {
        return this.rest.get<BaseCollectionModel<LicenseAssignmentResponse>>(`${this.segment}/list`, LicenseAssignmentResponse)
    }

    search(searchModel?: SearchModel): Observable<BaseCollectionModel<LicenseAssignmentResponse>> {
        return this.rest.post<SearchModel, BaseCollectionModel<LicenseAssignmentResponse>>(`${this.segment}/search`, LicenseAssignmentResponse, searchModel)
    }

    detail(guid: string): Observable<LicenseAssignmentResponse> {
        return this.rest.get(`${this.segment}/details/${guid}`, LicenseAssignmentResponse)
    }

    create(createRequest: LicenseAssignmentRequest) {
        return this.rest.post<LicenseAssignmentRequest, LicenseAssignmentResponse>(`${this.segment}/create`, LicenseAssignmentResponse, createRequest)
    }

    update(updateRequest: LicenseAssignmentRequest) {
        return this.rest.patch<LicenseAssignmentRequest, LicenseAssignmentResponse>(`${this.segment}/update`, LicenseAssignmentResponse, updateRequest)
    }

    delete(guid: string) {
        return this.rest.delete<void>(`${this.segment}/delete/${guid}`)
    }

    importCsvData(data: LicenseAssignmentCsvImportRequest): Observable<BaseCollectionModel<LicenseAssignmentResponse>> {
        return this.rest.post<LicenseAssignmentCsvImportRequest, BaseCollectionModel<LicenseAssignmentResponse>>(
            `${this.segment}/import/csv`,
            LicenseAssignmentResponse,
            data
        )
    }

    importExcelData(data: LicenseAssignmentCsvImportRequest): Observable<BaseCollectionModel<LicenseAssignmentResponse>> {
        return this.rest.post<LicenseAssignmentCsvImportRequest, BaseCollectionModel<LicenseAssignmentResponse>>(
            `${this.segment}/import/excel`,
            LicenseAssignmentResponse,
            data
        )
    }
}
